import { Component, ViewChild, ElementRef } from '@angular/core';
import { ChatService } from '../../services/chat/chat.service';
// import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-floating-chat',
  templateUrl: './floating-chat.component.html',
  styleUrls: ['./floating-chat.component.scss'], // optional
})
export class FloatingChatComponent {
  isChatOpen = false;
  isTyping = false;
  currentMessage = '';
  messages: any[] = [];

  @ViewChild('messagesContainer') messagesContainer!: ElementRef;

  constructor(private chat: ChatService) {}

    //   toggleChat() {
    //     this.isChatOpen = true;
    //     setTimeout(() => this.scrollToBottom(), 100);
    //   }
    toggleChat() {
    const wasClosed = !this.isChatOpen;
    this.isChatOpen = true;

    // Add greeting only if this is the first open and no messages yet
    if (wasClosed && this.messages.length === 0) {
        this.messages.push({
        from: 'bot',
        text: 'Hi! How can I assist you with your order today?',
        timestamp: new Date(),
        });
    }

    setTimeout(() => this.scrollToBottom(), 100);
    }

  minimizeChat() {
    this.isChatOpen = false; // Do not clear messages
  }

  closeChat() {
    this.isChatOpen = false;
    this.messages = []; // Clear chat
  }

  send() {
    const messageText = this.currentMessage.trim();
    if (!messageText) return;

    this.messages.push({
      from: 'user',
      text: messageText,
      timestamp: new Date(),
    });

    this.currentMessage = '';
    this.isTyping = true;
    this.scrollToBottom();

    this.chat.send(messageText).subscribe({
      next: (res) => {
        const replyText = res?.response || 'Sorry, no reply received.';
        this.messages.push({
          from: 'bot',
          text: replyText,
          timestamp: new Date(),
        });
        this.isTyping = false;
        this.scrollToBottom();
      },
      error: () => {
        this.messages.push({
          from: 'bot',
          text: 'Error: Failed to connect to AI service.',
          timestamp: new Date(),
        });
        this.isTyping = false;
        this.scrollToBottom();
      },
    });
  }

  scrollToBottom() {
    setTimeout(() => {
      if (this.messagesContainer) {
        const container = this.messagesContainer.nativeElement;
        container.scrollTop = container.scrollHeight;
      }
    }, 100);
  }

  openAttachmentMenu() {
    // currently disabled
  }
}
